import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'redux/store.types'

const authenticationStateSelector = (state: RootState) => state.authentication

export const isStaffAccountSelector = createSelector(
  authenticationStateSelector,
  (state) => state.isStaffUser,
)

export const authInitializedSelector = createSelector(
  authenticationStateSelector,
  (state) => state.authInitialized,
)
